/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/ArrowDropDown';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const ArrowDropDownIcon = withMuiAdapter(Base, 'ArrowDropDown');
